import { useTranslation } from "react-i18next";
import { Project, ProjectItem } from "./ProjectItem";

export default function Portfolio() {
  const { t } = useTranslation();

  const projects: Project[] = [
    {
      name: t("portfolio.projects.frat.name"),
      description: t("portfolio.projects.frat.descriptionShort"),
      demoUrl: "https://frat.com.pl/",
      repoUrl: "https://github.com/pawelmat142/frat",
      longDescription: [
        t("portfolio.projects.frat.longDescription.0"),
        t("portfolio.projects.frat.longDescription.1"),
        t("portfolio.projects.frat.longDescription.2"),
        t("portfolio.projects.frat.longDescription.3"),
      ],
      imgSrc: "/assets/projects/frat.jpg",
      nav: "frat",
    },
    {
      name: t("portfolio.projects.binancebot.name"),
      description: t("portfolio.projects.binancebot.description"),
      repoUrl: "https://github.com/pawelmat142/binance-bot",
      longDescription: [
        t("portfolio.projects.binancebot.longDescription.0"),
        t("portfolio.projects.binancebot.longDescription.1"),
        t("portfolio.projects.binancebot.longDescription.2"),
      ],
      imgSrc: "/assets/projects/binance-bot.jpg",
      nav: "binance-bot",
    },
    {
      name: t("portfolio.projects.stageart.name"),
      description: t("portfolio.projects.stageart.description"),
      demoUrl: "http://136.113.70.83/",
      repoUrl: "https://github.com/pawelmat142/book-agency",
      longDescription: [
        t("portfolio.projects.stageart.longDescription.0"),
        t("portfolio.projects.stageart.longDescription.1"),
        t("portfolio.projects.stageart.longDescription.2"),
      ],
      imgSrc: "/assets/projects/stage-art.jpg",
      nav: "stage-art",
    },
    // {
    //   name: t("portfolio.projects.zlotemysli.name"),
    //   description: t("portfolio.projects.zlotemysli.description"),
    //   demoUrl: "https://zlote-mysli.netlify.app/",
    //   repoUrl: "https://github.com/pawelmat142/zlote-mysli",
    //   longDescription: [
    //     t("portfolio.projects.zlotemysli.longDescription.0"),
    //     t("portfolio.projects.zlotemysli.longDescription.1"),
    //   ],
    //   imgSrc: "/assets/projects/zlote-mysli.jpg",
    //   nav: "zlote-mysli",
    // },
    // {
    //   name: t("portfolio.projects.pseudojackpot.name"),
    //   description: t("portfolio.projects.pseudojackpot.description"),
    //   demoUrl: "http://130.162.34.50:8001/",
    //   repoUrl: "https://github.com/pawelmat142/pseudoJackpot",
    //   longDescription: [
    //     t("portfolio.projects.pseudojackpot.longDescription.0"),
    //     t("portfolio.projects.pseudojackpot.longDescription.1"),
    //   ],
    //   imgSrc: "/assets/projects/jackpot.jpg",
    // },
  ];

  const getProjectId = (name: string) =>
    name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

  return (
    <div className="px-4 max-w-7xl">
      <h1 className="tx1 text-center pt-10 md:pt-20">
        {t("portfolio.title")}
      </h1>
      <div className="flex flex-col gap-10 mx-auto mb-10 md:mb-20">
        {projects.map((project) => (
          <section id={getProjectId(project.name)} key={project.name}>
            <ProjectItem project={project} />
          </section>
        ))}
      </div>
    </div>
  );
}